export default "__VITE_ASSET__kavk14L5__"